<div
  class="layout-topbar"
  [class.layout-topbar--panel-open]="layoutService.detailPanelPinned">
  <div class="layout-topbar__start">
    <button
      #menubutton
      type="button"
      class="p-link layout-menu-button layout-topbar-button lg:hidden"
      (click)="layoutService.onMenuToggle()">
      <i class="pi pi-bars"></i>
    </button>

    <a class="layout-topbar-logo" routerLink="/app/dashboard">
      <img
        src="assets/layout/images/{{
          layoutService.config.colorScheme === 'light'
            ? 'logo_dark'
            : 'logo_white'
        }}.svg"
        alt="logo" />
    </a>
  </div>

  <div class="layout-topbar__center">
    <button
      type="button"
      class="layout-topbar__panel-toggle"
      id="toggle-detail-panel"
      (click)="layoutService.toggleDetailPanel()"
      [attr.aria-label]="
        layoutService.detailPanelPinned ? 'Hide panel' : 'Show panel'
      ">
      <i
        class="pi"
        [ngClass]="
          layoutService.detailPanelPinned
            ? 'pi-angle-left'
            : 'pi-angle-right'
        "></i>
    </button>

    <button
      type="button"
      class="layout-topbar__company"
      [class.layout-topbar__company--static]="!canSwitchCompany"
      [disabled]="!canSwitchCompany"
      aria-haspopup="menu"
      [attr.aria-label]="'Active company: ' + getActiveCompanyDisplayLabel()"
      [attr.title]="canSwitchCompany ? 'Switch company' : null"
      (click)="companyMenu.toggle($event)">
      <span class="layout-topbar__company-dot"></span>
      <div class="layout-topbar__company-meta">
        <p class="company-badge-topic">Active Company</p>
        <p class="company-badge-text">
          {{ getActiveCompanyDisplayLabel() }}
        </p>
      </div>
      <i
        *ngIf="canSwitchCompany"
        class="pi pi-chevron-down layout-topbar__company-caret"></i>
    </button>
  </div>

  <button
    #topbarmenubutton
    type="button"
    class="p-link layout-topbar-menu-button layout-topbar-button"
    (click)="layoutService.showProfileSidebar()">
    <i class="pi pi-ellipsis-v"></i>
  </button>

  <div
    #topbarmenu
    class="layout-topbar-menu"
    [ngClass]="{
      'layout-topbar-menu-mobile-active':
        layoutService.state.profileSidebarVisible
    }">
    <div
      (click)="menu.toggle($event)"
      class="layout-topbar__profile lg:flex hidden">
      <div
        *ngIf="userLoading"
        class="flex items-center justify-between lg:justify-end gap-2">
        <p-skeleton shape="circle" size="2rem"></p-skeleton>
        <div class="flex flex-col justify-end">
          <div class="self-end">
            <p-skeleton width="5rem" styleClass="mb-1"></p-skeleton>
          </div>
          <div class="self-end">
            <p-skeleton width="3rem" styleClass="mb-1"></p-skeleton>
          </div>
        </div>
      </div>
      <div
        *ngIf="!userLoading"
        class="flex items-center lg:justify-end justify-between gap-2">
        <img
          *ngIf="!loggedInUser?.imageUrl"
          class="w-[1.75rem] h-[1.75rem] object-cover rounded-full"
          src="assets/images/static/img.jpg"
          alt="" />
        <img
          *ngIf="loggedInUser?.imageUrl"
          class="w-[1.75rem] h-[1.75rem] object-cover rounded-full"
          src="{{ loggedInUser?.imageUrl }}"
          alt="" />
        <div class="text-end">
          <h6 class="m-0 text-sm leading-tight">
            {{ loggedInUser?.firstname }} {{ loggedInUser?.lastname }}
          </h6>
          <p class="text-xs m-0 leading-tight">
            {{ loggedInUser?.role?.name | titlecase }}
          </p>
        </div>
      </div>
    </div>
    <button
      type="button"
      [routerLink]="['/app/user/profile/' + loggedInUser?._id]"
      class="p-link layout-topbar-button lg:hidden block">
      <span>Profile</span>
    </button>
    <button
      type="button"
      *ngIf="permissionService.hasPermission('BILLING_VIEW')"
      (click)="menu.toggle($event)"
      class="p-link layout-topbar-button lg:hidden block">
      <span>Invoice Generating</span>
    </button>
    <button
      type="button"
      (click)="mobileMenu.toggle($event)"
      class="p-link layout-topbar-button lg:hidden block">
      <span>Company</span>
    </button>
    <button
      type="button"
      (click)="logout()"
      class="p-link logout-link layout-topbar-button lg:hidden block">
      <span class="logout">Logout</span>
    </button>
  </div>
</div>
<p-confirmDialog key="companyFilter" header="Confirmation"></p-confirmDialog>
<p-tieredMenu
  #menu
  [model]="dropdownItems"
  [popup]="true"
  appendTo="body"></p-tieredMenu>
<p-tieredMenu
  #mobileMenu
  [model]="mobileDropdownItems"
  [popup]="true"
  appendTo="body"></p-tieredMenu>
<p-menu
  #companyMenu
  [model]="companyMenuItems"
  [popup]="true"
  appendTo="body"
  styleClass="topbar-company-menu"></p-menu>
